import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "checklist-item" }
const _hoisted_2 = {
  key: 0,
  class: "check-header"
}
const _hoisted_3 = { class: "check-title" }
const _hoisted_4 = { class: "check-content" }



interface Props {
  title: any;
  complete?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChecklistItemWrapper',
  props: {
    title: {},
    complete: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
            _createElementVNode("p", {
              class: _normalizeClass(["status", __props.complete ? 'complete' : 'incomplete'])
            }, _toDisplayString(__props.complete ? "Complete!" : "Items Needed"), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})